export const sleep = ({ millisecond = 1000 }: { millisecond?: number }) =>
  new Promise((resolve) => setTimeout(resolve, millisecond))
